module.exports = __webpack_public_path__ + "static/media/auditorium.0a45326b.jpg";